import React from 'react';
import Grid from '@mui/joy/Grid';

interface ConditionalGridProps {
  children: React.ReactNode;
  hidden?: boolean;
  xs?: number | 'auto';
  md?: number | 'auto';
  sm?: number | 'auto';
  lg?: number | 'auto';
  xl?: number | 'auto';
  [key: string]: any; // Allow other Grid props
}

/**
 * ConditionalGrid - A flexible Grid component that only renders when not hidden
 * This prevents empty spaces in the grid layout when fields are conditionally shown/hidden
 * 
 * Usage:
 * <ConditionalGrid xs={12} md={6} hidden={condition}>
 *   <YourComponent />
 * </ConditionalGrid>
 */
const ConditionalGrid: React.FC<ConditionalGridProps> = ({ 
  children, 
  hidden, 
  xs, 
  md, 
  sm, 
  lg, 
  xl,
  ...otherProps 
}) => {
  // If hidden, don't render anything (not even the Grid)
  if (hidden) {
    return null;
  }

  // Otherwise, render Grid with all props
  return (
    <Grid 
      xs={xs} 
      md={md} 
      sm={sm} 
      lg={lg} 
      xl={xl}
      {...otherProps}
    >
      {children}
    </Grid>
  );
};

export default ConditionalGrid;

